import React from 'react';

import DasherSlideshow from './slideshow_wrapper/dasher_slideshow_container.jsx';

const SlideshowBase_ViewerVersion3 = ({
  height,
  contentItemAssetPairs,
  ...props
}) => {
  // Early return in case we have nothing to render
  if (contentItemAssetPairs.length === 0) {
    return <div className='section-wrapper section-type-slideshow' />;
  }

  return (
    <DasherSlideshow
      slideHeight={height}
      contentItemAssetPairs={contentItemAssetPairs}
      {...props}
    />
  );
};

export default SlideshowBase_ViewerVersion3;
